
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from 'app/store/store'
import { IStepTree, ISaveProject, IFiles } from './types/StepTree-interface'

const StepTreeState = (state: RootState): IStepTree => state.StepTreeHealth

export const FormFieldsStepTree = createSelector(
    [StepTreeState],
    (state): IStepTree => state,
)
export const saveProjectState = createSelector(
    [StepTreeState],
    (state): ISaveProject => state.SaveProject,
)

export const files = createSelector(
    [StepTreeState],
    (state): IFiles => state.Files,
)